import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from '@appkit4/angular-components/checkbox';
import { DropdownModule } from '@appkit4/angular-components/dropdown';
import { FilterModule } from '@appkit4/angular-components/filter';
import { PaginationModule } from '@appkit4/angular-components/pagination';
import { PanelModule } from '@appkit4/angular-components/panel';
import { RadioModule } from '@appkit4/angular-components/radio';
import { DropDownAppkitOverlayListFixDirective } from '@shared/directives/appkit-dropdown-list-overlay-fix.directive';
import { SharedModule } from '@shared/shared.module';
import { HighchartsChartComponent } from 'highcharts-angular';
import { SkeletonModule } from 'primeng/skeleton';
import { CountryInformationModule } from '../country-information/country-information.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { TaxImpactMapComponent } from './components/tax-impact-map/tax-impact-map.component';
import { TaxImpactPanelComponent } from './components/tax-impact-panel/tax-impact-panel.component';
import { TaxNewsDetailModalComponent } from './components/tax-news-detail-modal/tax-news-detail-modal.component';
import { TaxNewsPanelComponent } from './components/tax-news-panel/tax-news-panel.component';
import { DashboardRoutingModule } from './dashboard-routing.module';

@NgModule({
  declarations: [
    DashboardComponent,
    SearchResultsComponent,
    TaxImpactMapComponent,
    TaxNewsPanelComponent,
    TaxNewsDetailModalComponent,
    TaxImpactPanelComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    DashboardRoutingModule,
    PanelModule,
    HighchartsChartComponent,
    CountryInformationModule,
    DropDownAppkitOverlayListFixDirective,
    CheckboxModule,
    FilterModule,
    RadioModule,
    FormsModule,
    PaginationModule,
    DropdownModule,
    SkeletonModule,
  ],
  exports: [],
})
export class DashboardModule {}
